import { EPaymentStatus, EPaymentType } from '../../types/reducers/paymentProcessing';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SET_PAYMENT_PROCESSING_STATUS = 'PAYMENT_PROCESSING :: SET_STATUS';

interface IPayload {
  type: EPaymentType;
  status: EPaymentStatus | null;
}

export type TSetPaymentProcessingStatusAction = IReduxAction<typeof SET_PAYMENT_PROCESSING_STATUS, IPayload>;

export const setPaymentProcessingStatus = actionGenerator<typeof SET_PAYMENT_PROCESSING_STATUS, IPayload>(
  SET_PAYMENT_PROCESSING_STATUS,
);
